"use strict";
var $ = require("../internals/export");
var isPrototypeOf = require("../internals/object-is-prototype-of");
var getPrototypeOf = require("../internals/object-get-prototype-of");
var setPrototypeOf = require("../internals/object-set-prototype-of");
var copyConstructorProperties = require("../internals/copy-constructor-properties");
var create = require("../internals/object-create");
var createNonEnumerableProperty = require("../internals/create-non-enumerable-property");
var createPropertyDescriptor = require("../internals/create-property-descriptor");
var installErrorCause = require("../internals/install-error-cause");
var installErrorStack = require("../internals/error-stack-install");
var iterate = require("../internals/iterate");
var normalizeStringArgument = require("../internals/normalize-string-argument");
var wellKnownSymbol = require("../internals/well-known-symbol");
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var $Error = Error;
var push = [].push;
var $AggregateError = function AggregateError(errors, message) {
  var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
  var that;
  if (setPrototypeOf) {
    that = setPrototypeOf(new $Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
  } else {
    that = isInstance ? this : create(AggregateErrorPrototype);
    createNonEnumerableProperty(that, TO_STRING_TAG, "Error");
  }
  if (message !== void 0) createNonEnumerableProperty(that, "message", normalizeStringArgument(message));
  installErrorStack(that, $AggregateError, that.stack, 1);
  if (arguments.length > 2) installErrorCause(that, arguments[2]);
  var errorsArray = [];
  iterate(errors, push, { that: errorsArray });
  createNonEnumerableProperty(that, "errors", errorsArray);
  return that;
};
if (setPrototypeOf) setPrototypeOf($AggregateError, $Error);
else copyConstructorProperties($AggregateError, $Error, { name: true });
var AggregateErrorPrototype = $AggregateError.prototype = create($Error.prototype, {
  constructor: createPropertyDescriptor(1, $AggregateError),
  message: createPropertyDescriptor(1, ""),
  name: createPropertyDescriptor(1, "AggregateError")
});
$({ global: true, constructor: true, arity: 2 }, {
  AggregateError: $AggregateError
});
